import { accountsApi } from "../api"
import { Alert, Button, Container, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material"
import { useCurrentAgreementId } from "../utils/route-hooks"
import { useAccount } from "../state/AppDataStateProvider"
import { useState } from "react"
import { PrepaymentEffect } from "@sb1finans/banking-api/dist/api"
import { LoadingButton } from "@mui/lab"

const ExtraInvoicePaymentPage = () => {

    const agreementId = useCurrentAgreementId()
    const account = useAccount()
    const [amount, setAmount] = useState("1000") // State for amount and payment effect selection can be added here
    const [paymentEffect, setPaymentEffect] = useState<PrepaymentEffect>(PrepaymentEffect.ReduceTermAmount)
    const [success, setSuccess] = useState<boolean | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    
    const onRequestExtraInvoicePayment = async () => {
        try {
            if (isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
                alert("Vennligst oppgi et gyldig beløp for ekstra fakturabetaling.")
                return
            }
            setIsLoading(true)
            const invoice = {
                accountId: account!!.id,
                amount: amount,
                prepaymentEffect: paymentEffect,
            }
            accountsApi.createExtraPaymentInvoice(agreementId, account!!.id, invoice)
            setSuccess(true)
            // Simulate extra invoice payment request
        } catch (error) {
            console.error("Error requesting extra invoice payment", error)
            setSuccess(false)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Container maxWidth="md">
            <Stack spacing={2}>
                { success === true && <Alert severity="info">Din forespørsel om ekstra fakturabetaling ble sendt inn.</Alert> }
                { success === false && <Alert severity="error">Det oppsto en feil ved innsending av forespørselen om ekstra fakturabetaling. Vennligst prøv igjen senere.</Alert> }
                <Typography variant="h4" gutterBottom>Ekstra fakturabetaling</Typography>
                <Typography variant="body1" gutterBottom>Her kan du be om en ekstra fakturabetaling. Dette kan være nyttig hvis du ønsker å betale en faktura tidligere enn forfallsdatoen.</Typography>
                <Typography variant="body2" gutterBottom>Vennligst klikk på knappen under for å sende inn forespørselen om ekstra fakturabetaling.</Typography>
                <form>
                    <TextField
                        label="Beløp"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                    { /* Radio butons for selectng whether payment should affect montly paymnents or term count. */ }
                    <Typography variant="body1" sx={{marginTop: 2}} gutterBottom>Hvordan ønsker du at denne ekstra betalingen skal påvirke lånet ditt?</Typography>
                    <RadioGroup
                        aria-label="payment-effect"
                        name="payment-effect"
                        value={paymentEffect}
                        onChange={(e) => setPaymentEffect(e.target.value as PrepaymentEffect)}
                    >
                        <FormControlLabel value={PrepaymentEffect.ReduceTermCount} control={<Radio />} label="Reduser antall terminer" />
                        <FormControlLabel value={PrepaymentEffect.ReduceTermAmount} control={<Radio />} label="Reduser månedlige betalinger" />
                    </RadioGroup>
                </form>
                <LoadingButton variant="contained" onClick={onRequestExtraInvoicePayment} loading={isLoading}>Be om ekstra fakturabetaling</LoadingButton>
            </Stack>
        </Container>
    );
}

export default ExtraInvoicePaymentPage;